import {
  initialState,
  Actions,
  State,
  GET_ALL_INSPECTIONS,
  GET_ALL_INSPECTIONS_SUCCESS,
  GET_ALL_INSPECTIONS_ERROR,
  RESET_GET_ALL_INSPECTIONS,
} from '../../types/inspection/get-all'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_INSPECTIONS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case GET_ALL_INSPECTIONS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case GET_ALL_INSPECTIONS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_GET_ALL_INSPECTIONS:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
